import { ApiService } from ".";
import { IUsersApiService } from "./IUsersApiService";
import { UserDetailsModel } from "../models/UserDetailsModel";
import { SimpleUserModel } from "../models/SimpleUserModel";
import { PagedModel } from "../models/PagedModel";

export class UsersApiService extends ApiService implements IUsersApiService {
    constructor(baseUrl: string, language?: string) {
        super(baseUrl, language);
    }

    public getSelf(): Promise<UserDetailsModel> {
        return this.get<UserDetailsModel>("users/self");
    }

    public getUserList(
        usernameFilter?: string,
        fullNameFilter?: string,
        emailFilter?: string,
        permissionFilter?:
            | "EndUsers"
            | "Administrators"
            | "FileAdmins"
            | "GroupAdmins"
            | "TemporaryUsers"
            | "SysAdmins",
        statusFilter?: "ActiveUsers" | "InactiveUsers" | "NeverSignedOnUsers" | "TemplateUsers",
        page: number = 1,
        perPage: number = 25,
        sortField: "username" | "fullname" | "email" | "lastLoginStamp" = "username",
        sortDirection: "ascending" | "descending" = "ascending"
    ): Promise<PagedModel<SimpleUserModel>> {
        return this.get<PagedModel<SimpleUserModel>>("users", {
            username: usernameFilter,
            fullName: fullNameFilter,
            email: emailFilter,
            permission: permissionFilter,
            status: statusFilter,
            page,
            perPage,
            sortField,
            sortDirection,
        });
    }
}
